import { createFileRoute, redirect } from '@tanstack/react-router';

// The sidebar's Find People page lives at /finder. People type the label as a
// path (/find-people), so send them there instead of to Page not found.
export const Route = createFileRoute('/find-people')({
  beforeLoad: ({ location }) => {
    throw redirect({ to: '/finder', search: location.search, replace: true });
  },
});
